import { useRef, useState } from "react";

import {
  C,
  MAX_PER_PRODUCT,
  ORDER_STATUS,
  SHIPPING_ZONES,
  calcCapacity,
  calcProductLoad,
  calcTotals,
  fmtDate,
  fmtMoney,
  genId,
  todayStr,
} from "../data/handcraftsConfig";

function createFallbackItem(product) {
  return {
    productId: product?.id ?? null,
    name: product?.name ?? "Producto personalizado",
    qty: 1,
    price: Number(product?.price) || 0,
    emoji: "ðŸ§¶",
  };
}

function AdminOrderBreakdown({ items, zoneId }) {
  const { subtotal, shipping, total, zone } = calcTotals(items, zoneId);
  return (
    <div style={{background:C.paper,borderRadius:14,padding:"16px 18px",border:`1.5px solid ${C.pink}22`}}>
      <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13,color:C.brown,marginBottom:10}}>📋 Desglose del Pedido</div>
      {items.map((item,i) => (
        <div key={i} style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
          <span style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brownMd}}>{item.emoji||"🧶"} {item.name} × {item.qty}</span>
          <span style={{fontFamily:"Nunito,sans-serif",fontSize:13,fontWeight:700,color:C.brown}}>{fmtMoney(item.price*item.qty)}</span>
        </div>
      ))}
      <div style={{borderTop:`1.5px solid ${C.pink}33`,margin:"10px 0"}}/>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
        <span style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brownMd}}>Subtotal</span>
        <span style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brown}}>{fmtMoney(subtotal)}</span>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
        <span style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brownMd}}>Envío — {zone.label}</span>
        <span style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brown}}>{shipping===0?"Gratis":fmtMoney(shipping)}</span>
      </div>
      <div style={{borderTop:`1.5px solid ${C.pink}33`,margin:"10px 0"}}/>
      <div style={{display:"flex",justifyContent:"space-between"}}>
        <span style={{fontFamily:"Nunito,sans-serif",fontSize:15,fontWeight:800,color:C.brown}}>TOTAL</span>
        <span style={{fontFamily:"Nunito,sans-serif",fontSize:18,fontWeight:800,color:C.pink}}>{fmtMoney(total)}</span>
      </div>
    </div>
  );
}

function AdminNewOrder({ orders, onSave, onClose, products }) {
  const safeProducts = Array.isArray(products) ? products : [];
  const defaultItem = createFallbackItem(safeProducts[0]);
  const [step, setStep]  = useState(1);
  const [cust, setCust]  = useState({ name:"", phone:"", instagram:"" });
  const [addr, setAddr]  = useState({ street:"", city:"", dept:"", country:"El Salvador", notes:"" });
  const [zone, setZone]  = useState("sv_metro");
  const [items, setItems]= useState([defaultItem]);
  const [notes, setNotes]= useState("");
  const [isPaid, setIsPaid]   = useState(false);
  const [payMethod, setPay]   = useState("");
  const { active, max } = calcCapacity(orders);
  const productLoad = calcProductLoad(orders);
  const ok = active < max;

  const inp = (val, cb, ph, type="text") => (
    <input type={type} value={val} onChange={cb} placeholder={ph}
      style={{width:"100%",padding:"11px 14px",borderRadius:12,border:`2px solid ${C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:14,outline:"none",background:C.white,boxSizing:"border-box"}}
      onFocus={e=>e.target.style.borderColor=C.pink} onBlur={e=>e.target.style.borderColor=C.paper}/>
  );

  const updateItem = (idx, field, val) => {
    setItems(prev => prev.map((it,i) => {
      if (i!==idx) return it;
      if (field==="productId") {
        const p = safeProducts.find(x => String(x.id) === String(val));
        if (!p) return it;
        return { ...it, productId:p.id, name:p.name, price:Number(p.price) || 0, emoji:"🧶" };
      }
      if (field==="qty") return { ...it, qty:Math.max(1,Number(val)||1) };
      if (field==="price") return { ...it, price:Math.max(0,Number(val)||0) };
      return { ...it, [field]: val };
    }));
  };
  const STEPS = ["Cliente","Productos","Envío","Resumen"];
  const { total } = calcTotals(items, zone);

  const saveIt = () => onSave({ id:genId(), createdAt:todayStr(), status:"pending", customer:cust, address:addr, shippingZone:zone, items, notes, isPaid, payMethod });

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(45,26,46,.7)",backdropFilter:"blur(8px)",zIndex:600,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:C.cream,borderRadius:28,width:"100%",maxWidth:540,maxHeight:"92vh",overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 24px 64px rgba(45,26,46,.3)"}}>
        <div style={{background:`linear-gradient(135deg,${C.pink},${C.purple})`,padding:"20px 26px",flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{fontFamily:"Playfair Display,serif",fontSize:19,fontWeight:700,color:"white"}}>Nuevo Pedido <span style={{fontSize:13,opacity:.7}}>({active}/{max})</span></div>
            <button onClick={onClose} style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:50,width:30,height:30,cursor:"pointer",color:"white",fontSize:15}}>✕</button>
          </div>
          <div style={{display:"flex",gap:3}}>
            {STEPS.map((_,i)=><div key={i} style={{flex:1,height:4,borderRadius:4,background:i+1<=step?"white":"rgba(255,255,255,.3)",cursor:i+1<step?"pointer":"default"}} onClick={()=>i+1<step&&setStep(i+1)}/>)}
          </div>
          <div style={{display:"flex",marginTop:4}}>
            {STEPS.map((s,i)=><div key={i} style={{flex:1,fontFamily:"Nunito,sans-serif",fontSize:10,color:i+1<=step?"white":"rgba(255,255,255,.45)",fontWeight:i+1===step?800:500,textAlign:"center"}}>{s}</div>)}
          </div>
        </div>

        {!ok && <div style={{background:"#fef2f2",padding:"10px 20px",fontFamily:"Nunito,sans-serif",fontSize:13,color:"#ef4444",fontWeight:700,flexShrink:0}}>⚠️ Capacidad llena ({max}/{max}). Finaliza pedidos antes de agregar más.</div>}

        <div style={{flex:1,overflow:"auto",padding:"22px 26px"}}>
          {step===1 && (
            <div>
              <h3 style={{fontFamily:"Playfair Display,serif",fontSize:17,marginBottom:16,color:C.brown}}>Cliente</h3>
              {[["name","Nombre *","Ana García"],["phone","Teléfono/WhatsApp *","7890-1234"],["instagram","Instagram","@cliente"]].map(([k,l,ph])=>(
                <div key={k} style={{marginBottom:12}}>
                  <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:700,color:C.brown,display:"block",marginBottom:4}}>{l}</label>
                  {inp(cust[k], e=>setCust(p=>({...p,[k]:e.target.value})), ph)}
                </div>
              ))}
            </div>
          )}
          {step===2 && (
            <div>
              <h3 style={{fontFamily:"Playfair Display,serif",fontSize:17,marginBottom:16,color:C.brown}}>Productos</h3>
              {safeProducts.length===0 && (
                <div style={{background:"#fffbeb",borderRadius:12,padding:"12px 14px",marginBottom:12,fontFamily:"Nunito,sans-serif",fontSize:13,color:"#92400e",border:"1.5px solid #fde68a"}}>
                  No hay productos cargados en el catalogo. Anade un producto primero desde la pestana de stock para crear pedidos sin errores.
                </div>
              )}
              {items.map((item,idx)=>{
                const load = productLoad[item.productId]||0;
                const over = load+item.qty > MAX_PER_PRODUCT;
                return (
                  <div key={idx} style={{background:C.white,borderRadius:14,padding:14,marginBottom:10,border:`1.5px solid ${over?"#fde68a":C.paper}`}}>
                    <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                      <span style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:700,color:C.brownMd}}>Producto {idx+1}</span>
                      {items.length>1&&<button onClick={()=>setItems(p=>p.filter((_,i)=>i!==idx))} style={{background:"#fef2f2",border:"none",borderRadius:8,padding:"2px 8px",cursor:"pointer",fontSize:12,color:"#ef4444",fontFamily:"Nunito,sans-serif",fontWeight:700}}>Quitar</button>}
                    </div>
                    <select value={item.productId ?? ""} onChange={e=>updateItem(idx,"productId",e.target.value)} disabled={safeProducts.length===0}
                      style={{width:"100%",padding:"10px 12px",borderRadius:10,border:`2px solid ${C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:14,background:C.white,outline:"none",marginBottom:8,boxSizing:"border-box"}}>
                      {safeProducts.length===0 ? (
                        <option value="">Sin productos disponibles</option>
                      ) : (
                        safeProducts.map(p=><option key={p.id} value={String(p.id)}>{p.name} — {fmtMoney(p.price)}</option>)
                      )}
                    </select>
                    <div style={{display:"flex",gap:10,alignItems:"flex-end"}}>
                      <div>
                        <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:C.brownLt,marginBottom:3}}>Cant.</div>
                        <input type="number" min={1} value={item.qty} onChange={e=>updateItem(idx,"qty",e.target.value)}
                          style={{width:65,padding:"8px 10px",borderRadius:10,border:`2px solid ${over?"#fde68a":C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:14,outline:"none"}}/>
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:C.brownLt,marginBottom:3}}>Precio unit.</div>
                        <input type="number" value={item.price} onChange={e=>updateItem(idx,"price",Number(e.target.value))}
                          style={{width:"100%",padding:"8px 10px",borderRadius:10,border:`2px solid ${C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:14,outline:"none",boxSizing:"border-box"}}/>
                      </div>
                      <div style={{textAlign:"right",paddingBottom:2}}>
                        <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:C.brownLt,marginBottom:3}}>Total</div>
                        <div style={{fontFamily:"Nunito,sans-serif",fontSize:15,fontWeight:800,color:C.pink}}>{fmtMoney(item.price*item.qty)}</div>
                      </div>
                    </div>
                    {over&&<div style={{marginTop:6,fontFamily:"Nunito,sans-serif",fontSize:11,color:"#92400e",fontWeight:700}}>⚠️ Alta carga para este producto ({load} activos)</div>}
                  </div>
                );
              })}
              <button onClick={()=>setItems(p=>[...p,createFallbackItem(safeProducts[0])])} disabled={safeProducts.length===0}
                style={{width:"100%",padding:10,borderRadius:12,border:`2px dashed ${C.pink}`,background:"transparent",fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:700,color:C.pink,cursor:safeProducts.length===0?"not-allowed":"pointer",opacity:safeProducts.length===0?.6:1}}>+ Agregar producto</button>
              <div style={{marginTop:12}}>
                <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:700,color:C.brown,display:"block",marginBottom:4}}>Notas / Personalización</label>
                <textarea value={notes} onChange={e=>setNotes(e.target.value)} rows={3} placeholder="Colores, detalles especiales..."
                  style={{width:"100%",padding:"11px 14px",borderRadius:12,border:`2px solid ${C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:13,outline:"none",resize:"vertical",background:C.white,lineHeight:1.6,boxSizing:"border-box"}}
                  onFocus={e=>e.target.style.borderColor=C.pink} onBlur={e=>e.target.style.borderColor=C.paper}/>
              </div>
            </div>
          )}
          {step===3 && (
            <div>
              <h3 style={{fontFamily:"Playfair Display,serif",fontSize:17,marginBottom:16,color:C.brown}}>Envío</h3>
              <div style={{display:"flex",flexDirection:"column",gap:7,marginBottom:14}}>
                {SHIPPING_ZONES.map(z=>(
                  <label key={z.id} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 14px",borderRadius:12,border:`2px solid ${zone===z.id?C.pink:C.paper}`,background:zone===z.id?C.rose:C.white,cursor:"pointer",transition:"all .15s"}}>
                    <input type="radio" name="adminzone" value={z.id} checked={zone===z.id} onChange={e=>setZone(e.target.value)} style={{accentColor:C.pink}}/>
                    <div style={{flex:1}}>
                      <div style={{fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:700,color:C.brown}}>{z.label}</div>
                      <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:C.brownLt}}>{z.days}</div>
                    </div>
                    <div style={{fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:800,color:C.pink}}>{z.price===0?"Gratis":fmtMoney(z.price)}</div>
                  </label>
                ))}
              </div>
              {zone!=="pickup" && [["street","Dirección","Col. Escalón #45"],["city","Ciudad","San Salvador"],["dept","Departamento","San Salvador"],["country","País","El Salvador"],["notes","Indicaciones","Timbre azul..."]].map(([k,l,ph])=>(
                <div key={k} style={{marginBottom:10}}>
                  <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:700,color:C.brown,display:"block",marginBottom:4}}>{l}</label>
                  {inp(addr[k], e=>setAddr(p=>({...p,[k]:e.target.value})), ph)}
                </div>
              ))}
            </div>
          )}
          {step===4 && (
            <div>
              <h3 style={{fontFamily:"Playfair Display,serif",fontSize:17,marginBottom:14,color:C.brown}}>Resumen</h3>
              <div style={{background:C.white,borderRadius:12,padding:14,marginBottom:12,border:`1.5px solid ${C.paper}`}}>
                <div style={{fontFamily:"Nunito,sans-serif",fontSize:15,fontWeight:700,color:C.brown}}>{cust.name}</div>
                <div style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brownMd}}>{cust.phone}{cust.instagram&&` · ${cust.instagram}`}</div>
                <div style={{fontFamily:"Nunito,sans-serif",fontSize:12,color:C.brownLt,marginTop:3}}>
                  {zone==="pickup"?"📍 Recoger en persona":`📍 ${addr.street}, ${addr.city}, ${addr.country}`}
                </div>
              </div>
              {notes&&<div style={{background:"#fffbeb",borderRadius:10,padding:"10px 14px",marginBottom:12,fontFamily:"Nunito,sans-serif",fontSize:13,color:"#78350f",border:"1.5px solid #fde68a"}}>📝 {notes}</div>}
              <AdminOrderBreakdown items={items} zoneId={zone}/>
              <div style={{background:C.white,borderRadius:12,padding:14,marginTop:12,border:`1.5px solid ${C.paper}`}}>
                <label style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",marginBottom:isPaid?12:0}}>
                  <input type="checkbox" checked={isPaid} onChange={e=>setIsPaid(e.target.checked)} style={{width:18,height:18,accentColor:C.pink}}/>
                  <span style={{fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:700,color:isPaid?"#10b981":C.brownMd}}>{isPaid?`✅ Pago recibido (${fmtMoney(total)})`:"⏳ Pago pendiente"}</span>
                </label>
                {isPaid&&(
                  <select value={payMethod} onChange={e=>setPay(e.target.value)}
                    style={{width:"100%",padding:"10px 12px",borderRadius:10,border:`2px solid ${C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:14,background:C.white,outline:"none",boxSizing:"border-box"}}>
                    <option value="">Método...</option>
                    {["Wompi","Efectivo","Transferencia","Otro"].map(m=><option key={m} value={m}>{m}</option>)}
                  </select>
                )}
              </div>
            </div>
          )}
        </div>

        <div style={{padding:"14px 26px",borderTop:`1.5px solid ${C.paper}`,display:"flex",gap:10,background:C.white,flexShrink:0}}>
          {step>1&&<button onClick={()=>setStep(s=>s-1)} style={{padding:"11px 20px",borderRadius:50,border:`2px solid ${C.paper}`,background:"transparent",fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:700,color:C.brownMd,cursor:"pointer"}}>← Atrás</button>}
          <button onClick={()=>step<4?setStep(s=>s+1):saveIt()}
            disabled={!ok||(step===1&&!cust.name)}
            style={{flex:1,padding:"12px 0",borderRadius:50,border:"none",background:`linear-gradient(135deg,${C.pink},${C.purple})`,color:"white",fontFamily:"Nunito,sans-serif",fontSize:15,fontWeight:800,cursor:"pointer",boxShadow:`0 4px 0 ${C.pinkDk}`,opacity:(!ok||(step===1&&!cust.name))?.5:1}}>
            {step<4?"Continuar →":"✅ Guardar Pedido"}
          </button>
        </div>
      </div>
    </div>
  );
}

function AdminOrderDetail({ order, onClose, onUpdate, onDelete }) {
  const [status, setStatus]   = useState(order.status);
  const [isPaid, setIsPaid]   = useState(order.isPaid);
  const [payMethod, setPay]   = useState(order.payMethod);
  const safeItems = Array.isArray(order.items) ? order.items : [];
  const customerName = order.customer?.name || "Cliente sin nombre";
  const customerPhone = order.customer?.phone || "";
  const customerInstagram = order.customer?.instagram || "";
  const { total } = calcTotals(safeItems, order.shippingZone);
  const zone = SHIPPING_ZONES.find(z=>z.id===order.shippingZone);

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(45,26,46,.7)",backdropFilter:"blur(8px)",zIndex:600,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
      <div style={{background:C.cream,borderRadius:28,width:"100%",maxWidth:500,maxHeight:"90vh",overflow:"auto",boxShadow:"0 24px 64px rgba(45,26,46,.3)"}}>
        <div style={{background:`linear-gradient(135deg,${C.purple},${C.pink})`,padding:"20px 26px",borderRadius:"28px 28px 0 0",display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <div>
            <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:"rgba(255,255,255,.65)",marginBottom:2}}>#{order.id} · {fmtDate(order.createdAt)}</div>
            <div style={{fontFamily:"Playfair Display,serif",fontSize:20,color:"white",fontWeight:700}}>{customerName}</div>
            <div style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:"rgba(255,255,255,.8)",marginTop:2}}>{customerPhone}{customerInstagram&&` · ${customerInstagram}`}</div>
          </div>
          <button onClick={onClose} style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:50,width:30,height:30,cursor:"pointer",color:"white",fontSize:15,flexShrink:0}}>✕</button>
        </div>

        <div style={{padding:"20px 26px",display:"flex",flexDirection:"column",gap:12}}>
          <div style={{background:C.white,borderRadius:14,padding:14,border:`1.5px solid ${C.paper}`}}>
            <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,fontWeight:800,color:C.brownLt,textTransform:"uppercase",letterSpacing:"1px",marginBottom:8}}>Estado</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
              {Object.entries(ORDER_STATUS).map(([k,cfg])=>(
                <button key={k} onClick={()=>setStatus(k)} style={{padding:"6px 11px",borderRadius:20,border:`2px solid ${status===k?cfg.color:C.paper}`,background:status===k?cfg.bg:C.white,fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:700,color:status===k?cfg.color:C.brownLt,cursor:"pointer",transition:"all .15s"}}>
                  {cfg.icon} {cfg.label}
                </button>
              ))}
            </div>
          </div>

          {order.shippingZone!=="pickup" && order.address?.street && (
            <div style={{background:C.white,borderRadius:14,padding:14,border:`1.5px solid ${C.paper}`}}>
              <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,fontWeight:800,color:C.brownLt,textTransform:"uppercase",letterSpacing:"1px",marginBottom:6}}>📍 Dirección</div>
              <div style={{fontFamily:"Nunito,sans-serif",fontSize:14,color:C.brown,lineHeight:1.7}}>
                {order.address.street}<br/>{order.address.city}, {order.address.dept}<br/>{order.address.country}
                {order.address.notes&&<><br/><span style={{color:C.brownLt,fontSize:12}}>💬 {order.address.notes}</span></>}
              </div>
              {zone&&<div style={{marginTop:6,fontFamily:"Nunito,sans-serif",fontSize:12,color:C.pink,fontWeight:700}}>{zone.label} — {zone.days}</div>}
            </div>
          )}
          {order.shippingZone==="pickup"&&<div style={{background:"#f0fdf4",borderRadius:12,padding:"12px 14px",border:"1.5px solid #bbf7d0",fontFamily:"Nunito,sans-serif",fontSize:13,color:"#166534",fontWeight:700}}>🏠 Recoger en persona — gratis</div>}
          {order.notes&&<div style={{background:"#fffbeb",borderRadius:12,padding:"12px 14px",border:"1.5px solid #fde68a",fontFamily:"Nunito,sans-serif",fontSize:13,color:"#78350f"}}>📝 {order.notes}</div>}

          <AdminOrderBreakdown items={safeItems} zoneId={order.shippingZone}/>

          <div style={{background:C.white,borderRadius:14,padding:14,border:`1.5px solid ${C.paper}`}}>
            <label style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer",marginBottom:isPaid?12:0}}>
              <input type="checkbox" checked={isPaid} onChange={e=>setIsPaid(e.target.checked)} style={{width:18,height:18,accentColor:C.pink}}/>
              <span style={{fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:700,color:isPaid?"#10b981":C.brownMd}}>{isPaid?`✅ Pagado — ${fmtMoney(total)}`:"⏳ Pago pendiente"}</span>
            </label>
            {isPaid&&(
              <select value={payMethod} onChange={e=>setPay(e.target.value)}
                style={{width:"100%",padding:"10px 12px",borderRadius:10,border:`2px solid ${C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:14,background:C.white,outline:"none",boxSizing:"border-box"}}>
                <option value="">Método...</option>
                {["Wompi","Efectivo","Transferencia","Otro"].map(m=><option key={m} value={m}>{m}</option>)}
              </select>
            )}
          </div>

          <div style={{display:"flex",gap:10}}>
            <button onClick={()=>{if(window.confirm("¿Eliminar?"))onDelete(order.id)}} style={{padding:"10px 14px",borderRadius:50,border:"2px solid #fee2e2",background:"#fef2f2",fontFamily:"Nunito,sans-serif",fontSize:13,fontWeight:700,color:"#ef4444",cursor:"pointer"}}>🗑</button>
            <button onClick={()=>onUpdate({...order,status,isPaid,payMethod:isPaid?payMethod:order.payMethod})}
              style={{flex:1,padding:"12px 0",borderRadius:50,border:"none",background:`linear-gradient(135deg,${C.pink},${C.purple})`,color:"white",fontFamily:"Nunito,sans-serif",fontSize:15,fontWeight:800,cursor:"pointer",boxShadow:`0 4px 0 ${C.pinkDk}`}}>
              💾 Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function AdminDashboard({ orders, products, setOrders, soldIds, onRestock, onExit, onSaveProduct, onDeleteProduct }) {
  const [tab, setTab]           = useState("orders");
  const [showNew, setShowNew]   = useState(false);
  const [selected, setSelected] = useState(null);
  const [filter, setFilter]     = useState("all");
  const [search, setSearch]     = useState("");
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [editProduct, setEditProduct]       = useState(null); // product being edited

  const saveOrder   = o => {
    const splitOrders = (Array.isArray(o.items) ? o.items : []).map((item, index) => ({
      ...o,
      id: `${o.id}-${index + 1}`,
      items: [item],
    }));
    setOrders(p=>[...p, ...(splitOrders.length ? splitOrders : [o])]);
    setShowNew(false);
  };
  const updateOrder = o => { setOrders(p=>p.map(x=>x.id===o.id?o:x)); setSelected(null); };
  const deleteOrder = id=> { setOrders(p=>p.filter(x=>x.id!==id)); setSelected(null); };

  const allProducts = products;

  const { active, pct, max } = calcCapacity(orders);
  const productLoad = calcProductLoad(orders);
  const totalRevenue = orders.filter(o=>o.isPaid).reduce((s,o)=>s+calcTotals(o.items,o.shippingZone).total,0);
  const capColor = pct>=90?"#ef4444":pct>=70?"#f59e0b":"#10b981";

  const filtered = orders
    .filter(o=>(filter==="all"||o.status===filter)&&(!search||o.customer.name.toLowerCase().includes(search.toLowerCase())||o.id.toLowerCase().includes(search.toLowerCase())))
    .sort((a,b)=>new Date(b.createdAt)-new Date(a.createdAt));

  // ── Add/Edit Product Modal ───────────────────────────────────────────────
  const ProductForm = ({ existing, onClose }) => {
    const [name,     setName]     = useState(existing?.name     || "");
    const [price,    setPrice]    = useState(existing?.price    || "");
    const [cat,      setCat]      = useState(existing?.cat      || "Religiosos");
    const [stock,    setStock]    = useState(existing?.stock    ?? 1);
    const [desc,     setDesc]     = useState(existing?.desc     || "");
    const [tiempo,   setTiempo]   = useState(existing?.tiempo   || "5–7 días");
    const [dificultad, setDif]    = useState(existing?.dificultad || "Intermedio");
    const [badge,    setBadge]    = useState(existing?.badge    || "");
    const [imgData,  setImgData]  = useState(existing?.img      || null);
    const [imgError, setImgError] = useState("");
    const [cropOpen, setCropOpen] = useState(false);
    const [cropSource, setCropSource] = useState(null);
    const [cropScale, setCropScale] = useState(1);
    const [cropX, setCropX] = useState(0);
    const [cropY, setCropY] = useState(0);
    const [cropImgSize, setCropImgSize] = useState({ width: 0, height: 0 });
    const fileRef = useRef(null);
    const cropImageRef = useRef(null);

    const resetCropState = () => {
      setCropScale(1);
      setCropX(0);
      setCropY(0);
      setCropImgSize({ width: 0, height: 0 });
    };

    const openCropper = (source) => {
      setCropSource(source);
      resetCropState();
      setCropOpen(true);
    };

    const handleImage = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) { setImgError("Imagen muy grande (m??x 5MB)"); return; }
      const reader = new FileReader();
      reader.onload = (ev) => { openCropper(ev.target.result); setImgError(""); };
      reader.readAsDataURL(file);
    };

    const applyCrop = () => {
      const image = cropImageRef.current;
      if (!image) return;

      const frameSize = 900;
      const canvas = document.createElement("canvas");
      canvas.width = frameSize;
      canvas.height = frameSize;
      const ctx = canvas.getContext("2d");
      if (!ctx) return;

      const displayWidth = cropImgSize.width * cropScale;
      const displayHeight = cropImgSize.height * cropScale;
      const offsetX = (frameSize - displayWidth) / 2 + cropX;
      const offsetY = (frameSize - displayHeight) / 2 + cropY;

      ctx.fillStyle = "#fdf6fb";
      ctx.fillRect(0, 0, frameSize, frameSize);
      ctx.drawImage(image, offsetX, offsetY, displayWidth, displayHeight);

      setImgData(canvas.toDataURL("image/jpeg", 0.92));
      setCropOpen(false);
      setCropSource(null);
    };

    const handleSave = () => {
      if (!name.trim() || !price || !imgData) return;
      const product = {
        id: existing?.id || ("custom_" + Date.now()),
        name: name.trim(),
        price: Number(price),
        cat, stock: Number(stock),
        desc: desc.trim() || `${name} tejido a mano con amor por Abu.`,
        tiempo, dificultad, badge: badge.trim(),
        img: imgData,
        isCustom: true,
      };
      onSaveProduct(product);
      onClose();
    };

    const inp = (val, cb, ph, type="text", extra={}) => (
      <input type={type} value={val} onChange={e=>cb(e.target.value)} placeholder={ph} {...extra}
        style={{width:"100%",padding:"10px 13px",borderRadius:11,border:`2px solid ${C.paper}`,
          fontFamily:"Nunito,sans-serif",fontSize:14,outline:"none",background:C.white,boxSizing:"border-box"}}
        onFocus={e=>e.target.style.borderColor=C.pink}
        onBlur={e=>e.target.style.borderColor=C.paper}/>
    );

    const canSave = name.trim() && price && imgData;

    return (
      <>
      <div style={{position:"fixed",inset:0,background:"rgba(45,26,46,.75)",backdropFilter:"blur(8px)",
        zIndex:700,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
        <div style={{background:C.cream,borderRadius:26,width:"100%",maxWidth:520,maxHeight:"94vh",
          overflow:"hidden",display:"flex",flexDirection:"column",boxShadow:"0 24px 64px rgba(45,26,46,.35)"}}>

          {/* Header */}
          <div style={{background:`linear-gradient(135deg,${C.pink},${C.purple})`,padding:"18px 24px",flexShrink:0,
            display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontFamily:"Playfair Display,serif",fontSize:18,fontWeight:700,color:"white"}}>
              {existing ? "✏️ Editar Producto" : "✨ Nuevo Producto"}
            </div>
            <button onClick={onClose} style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:50,
              width:30,height:30,cursor:"pointer",color:"white",fontSize:15,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
          </div>

          <div style={{flex:1,overflowY:"auto",padding:"20px 24px",display:"flex",flexDirection:"column",gap:14}}>

            {/* Server save notice */}
            <div style={{background:"#f0fdf4",border:"2px solid #22c55e",borderRadius:12,padding:"10px 14px",
              display:"flex",alignItems:"flex-start",gap:10}}>
              <span style={{fontSize:18,flexShrink:0}}>🌐</span>
              <div style={{fontFamily:"Nunito,sans-serif",fontSize:12,color:"#166534",lineHeight:1.5}}>
                <strong>Se guarda en el servidor.</strong> Este producto aparecerá en el catálogo para todos los visitantes del sitio.
              </div>
            </div>

            {/* Image upload */}
            <div>
              <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown,display:"block",marginBottom:8}}>
                📸 Foto del Producto *
              </label>
              <div onClick={()=>fileRef.current?.click()}
                style={{width:"100%",height:180,borderRadius:16,border:`2.5px dashed ${imgData?C.pink:C.brownLt}`,
                  background:imgData?"transparent":C.paper,cursor:"pointer",overflow:"hidden",
                  display:"flex",alignItems:"center",justifyContent:"center",position:"relative",transition:"border-color .2s"}}>
                {imgData
                  ? <img src={imgData} alt="preview" style={{width:"100%",height:"100%",objectFit:"contain",background:"#fdf6fb",padding:4,boxSizing:"border-box"}}/>
                  : <div style={{textAlign:"center",color:C.brownLt}}>
                      <div style={{fontSize:36,marginBottom:8}}>📷</div>
                      <div style={{fontFamily:"Nunito,sans-serif",fontSize:13,fontWeight:700}}>Subir foto</div>
                      <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,marginTop:4}}>JPG, PNG · máx 5MB</div>
                    </div>
                }
                {imgData && (
                  <div style={{position:"absolute",inset:0,background:"rgba(45,26,46,.0)",display:"flex",
                    alignItems:"center",justifyContent:"center",opacity:0,transition:"opacity .2s"}}
                    onMouseEnter={e=>e.currentTarget.style.opacity=1}
                    onMouseLeave={e=>e.currentTarget.style.opacity=0}>
                    <div style={{background:"rgba(45,26,46,.7)",borderRadius:12,padding:"8px 16px",
                      fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:700,color:"white"}}>
                      Cambiar foto
                    </div>
                  </div>
                )}
              </div>
              <input ref={fileRef} type="file" accept="image/*" onChange={handleImage} style={{display:"none"}}/>
              {imgData && (
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:8,gap:8,flexWrap:"wrap"}}>
                  <span style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:C.brownLt}}>
                    Ajusta la imagen para que quede centrada en la tarjeta del producto.
                  </span>
                  <button type="button" onClick={() => openCropper(imgData)} style={{padding:"6px 12px",borderRadius:20,border:`2px solid ${C.paper}`,background:C.white,fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brownMd,cursor:"pointer"}}>
                    Recortar / Ajustar
                  </button>
                </div>
              )}
              {imgError && <p style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:"#ef4444",marginTop:4,fontWeight:700}}>{imgError}</p>}
            </div>

            {/* Name + Price row */}
            <div style={{display:"grid",gridTemplateColumns:"1fr auto",gap:12,alignItems:"end"}}>
              <div>
                <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown,display:"block",marginBottom:5}}>Nombre *</label>
                {inp(name, setName, "Ej: Ángel Tejido")}
              </div>
              <div style={{width:100}}>
                <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown,display:"block",marginBottom:5}}>Precio (USD) *</label>
                <div style={{position:"relative"}}>
                  <span style={{position:"absolute",left:11,top:"50%",transform:"translateY(-50%)",
                    fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:800,color:C.brownMd}}>$</span>
                  <input type="number" value={price} onChange={e=>setPrice(e.target.value)} placeholder="0"
                    min={1} step={0.01}
                    style={{width:"100%",padding:"10px 10px 10px 24px",borderRadius:11,border:`2px solid ${C.paper}`,
                      fontFamily:"Nunito,sans-serif",fontSize:15,fontWeight:800,outline:"none",
                      background:C.white,color:C.pink,boxSizing:"border-box"}}
                    onFocus={e=>e.target.style.borderColor=C.pink}
                    onBlur={e=>e.target.style.borderColor=C.paper}/>
                </div>
              </div>
            </div>

            {/* Category + Stock row */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div>
                <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown,display:"block",marginBottom:5}}>Categoría</label>
                <select value={cat} onChange={e=>setCat(e.target.value)}
                  style={{width:"100%",padding:"10px 13px",borderRadius:11,border:`2px solid ${C.paper}`,
                    fontFamily:"Nunito,sans-serif",fontSize:14,background:C.white,outline:"none",color:C.brown,boxSizing:"border-box"}}
                  onFocus={e=>e.target.style.borderColor=C.pink}
                  onBlur={e=>e.target.style.borderColor=C.paper}>
                  {["Religiosos","Animales","Muñecas","Sets","Bebés","Otros"].map(c=><option key={c} value={c}>{c}</option>)}
                </select>
              </div>
              <div>
                <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown,display:"block",marginBottom:5}}>
                  Unidades en stock
                </label>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <button onClick={()=>setStock(s=>Math.max(0,s-1))}
                    style={{width:36,height:40,borderRadius:10,border:`2px solid ${C.paper}`,background:C.white,
                      fontSize:18,fontWeight:800,cursor:"pointer",color:C.pink,flexShrink:0,fontFamily:"Nunito,sans-serif"}}>−</button>
                  <input type="number" value={stock} onChange={e=>setStock(Math.max(0,Number(e.target.value)))}
                    min={0} style={{flex:1,padding:"10px 0",borderRadius:11,border:`2px solid ${C.paper}`,
                      fontFamily:"Nunito,sans-serif",fontSize:16,fontWeight:800,textAlign:"center",
                      outline:"none",background:C.white,color:stock===0?"#ef4444":C.brown}}
                    onFocus={e=>e.target.style.borderColor=C.pink}
                    onBlur={e=>e.target.style.borderColor=C.paper}/>
                  <button onClick={()=>setStock(s=>s+1)}
                    style={{width:36,height:40,borderRadius:10,border:`2px solid ${C.paper}`,background:C.white,
                      fontSize:18,fontWeight:800,cursor:"pointer",color:C.pink,flexShrink:0,fontFamily:"Nunito,sans-serif"}}>+</button>
                </div>
                <div style={{fontFamily:"Nunito,sans-serif",fontSize:10,color:C.brownLt,marginTop:4,textAlign:"center"}}>
                  {stock===0?"Se mostrará como agotado":stock===1?"¡Última unidad!":stock+" unidades"}
                </div>
              </div>
            </div>

            {/* Badge + Tiempo row */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div>
                <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown,display:"block",marginBottom:5}}>Etiqueta (opcional)</label>
                {inp(badge, setBadge, "Ej: Nueva, Especial...")}
              </div>
              <div>
                <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown,display:"block",marginBottom:5}}>Tiempo de entrega</label>
                {inp(tiempo, setTiempo, "Ej: 7–10 días")}
              </div>
            </div>

            {/* Dificultad */}
            <div>
              <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown,display:"block",marginBottom:5}}>Dificultad</label>
              <div style={{display:"flex",gap:8}}>
                {["Fácil","Intermedio","Avanzado"].map(d=>(
                  <button key={d} onClick={()=>setDif(d)}
                    style={{flex:1,padding:"9px 0",borderRadius:11,border:`2px solid ${dificultad===d?C.pink:C.paper}`,
                      background:dificultad===d?C.rose:C.white,fontFamily:"Nunito,sans-serif",fontSize:13,
                      fontWeight:700,color:dificultad===d?C.pink:C.brownMd,cursor:"pointer",transition:"all .15s"}}>
                    {d}
                  </button>
                ))}
              </div>
            </div>

            {/* Description */}
            <div>
              <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown,display:"block",marginBottom:5}}>Descripción</label>
              <textarea value={desc} onChange={e=>setDesc(e.target.value)} rows={3}
                placeholder="Describe el producto, materiales, detalles especiales..."
                style={{width:"100%",padding:"10px 13px",borderRadius:11,border:`2px solid ${C.paper}`,
                  fontFamily:"Nunito,sans-serif",fontSize:13,outline:"none",resize:"vertical",
                  background:C.white,lineHeight:1.6,boxSizing:"border-box"}}
                onFocus={e=>e.target.style.borderColor=C.pink}
                onBlur={e=>e.target.style.borderColor=C.paper}/>
            </div>
          </div>

          {/* Footer */}
          <div style={{padding:"14px 24px",borderTop:`1.5px solid ${C.paper}`,background:C.white,flexShrink:0,display:"flex",gap:10}}>
            <button onClick={onClose}
              style={{padding:"11px 18px",borderRadius:50,border:`2px solid ${C.paper}`,background:"transparent",
                fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:700,color:C.brownMd,cursor:"pointer"}}>
              Cancelar
            </button>
            <button onClick={handleSave} disabled={!canSave}
              style={{flex:1,padding:"13px 0",borderRadius:50,border:"none",
                background:canSave?`linear-gradient(135deg,${C.pink},${C.purple})`:"#e2d6e8",
                color:"white",fontFamily:"Nunito,sans-serif",fontSize:15,fontWeight:800,
                cursor:canSave?"pointer":"not-allowed",
                boxShadow:canSave?`0 4px 0 ${C.pinkDk}`:"none",transition:"all .2s"}}>
              {existing ? "💾 Guardar Cambios" : "✨ Agregar Producto"}
            </button>
          </div>
        </div>
      </div>

      {cropOpen && cropSource && (
        <div style={{position:"fixed",inset:0,background:"rgba(45,26,46,.75)",backdropFilter:"blur(8px)",zIndex:800,display:"flex",alignItems:"center",justifyContent:"center",padding:16}}>
          <div style={{background:C.cream,borderRadius:24,width:"100%",maxWidth:640,boxShadow:"0 24px 64px rgba(45,26,46,.35)",overflow:"hidden"}}>
            <div style={{background:`linear-gradient(135deg,${C.pink},${C.purple})`,padding:"18px 24px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div style={{fontFamily:"Playfair Display,serif",fontSize:18,fontWeight:700,color:"white"}}>Ajustar imagen</div>
              <button onClick={()=>{ setCropOpen(false); setCropSource(null); }} style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:50,width:30,height:30,cursor:"pointer",color:"white",fontSize:15}}>×</button>
            </div>
            <div style={{padding:24}}>
              <div style={{display:"grid",gridTemplateColumns:"minmax(0, 1fr) 180px",gap:20,alignItems:"start"}}>
                <div>
                  <div style={{width:"100%",maxWidth:380,aspectRatio:"1 / 1",margin:"0 auto",borderRadius:20,overflow:"hidden",background:"#fdf6fb",border:`2px solid ${C.paper}`,position:"relative",boxShadow:"inset 0 0 0 1px rgba(217,79,160,.08)"}}>
                    <img ref={cropImageRef} src={cropSource} alt="Crop preview" onLoad={(e)=>setCropImgSize({ width: e.currentTarget.naturalWidth, height: e.currentTarget.naturalHeight })} style={{position:"absolute",top:"50%",left:"50%",width: cropImgSize.width ? `${cropImgSize.width * cropScale}px` : "100%",height: cropImgSize.height ? `${cropImgSize.height * cropScale}px` : "100%",objectFit:"contain",transform:`translate(calc(-50% + ${cropX}px), calc(-50% + ${cropY}px))`,transformOrigin:"center center",userSelect:"none",pointerEvents:"none"}} />
                  </div>
                  <p style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:C.brownLt,textAlign:"center",marginTop:10}}>Vista previa cuadrada de la foto final del producto.</p>
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:14}}>
                  <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown}}>Zoom<input type="range" min="0.7" max="2.4" step="0.01" value={cropScale} onChange={e=>setCropScale(Number(e.target.value))} style={{width:"100%",marginTop:8}} /></label>
                  <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown}}>Mover horizontal<input type="range" min="-220" max="220" step="1" value={cropX} onChange={e=>setCropX(Number(e.target.value))} style={{width:"100%",marginTop:8}} /></label>
                  <label style={{fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brown}}>Mover vertical<input type="range" min="-220" max="220" step="1" value={cropY} onChange={e=>setCropY(Number(e.target.value))} style={{width:"100%",marginTop:8}} /></label>
                  <button type="button" onClick={resetCropState} style={{padding:"10px 12px",borderRadius:14,border:`2px solid ${C.paper}`,background:C.white,fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:800,color:C.brownMd,cursor:"pointer"}}>Recentrar</button>
                </div>
              </div>
            </div>
            <div style={{padding:"16px 24px",borderTop:`1.5px solid ${C.paper}`,display:"flex",gap:10,justifyContent:"flex-end",background:C.white}}>
              <button onClick={()=>{ setCropOpen(false); setCropSource(null); }} style={{padding:"11px 18px",borderRadius:50,border:`2px solid ${C.paper}`,background:"transparent",fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:700,color:C.brownMd,cursor:"pointer"}}>Cancelar</button>
              <button onClick={applyCrop} style={{padding:"12px 20px",borderRadius:50,border:"none",background:`linear-gradient(135deg,${C.pink},${C.purple})`,color:"white",fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:800,cursor:"pointer",boxShadow:`0 4px 0 ${C.pinkDk}`}}>Usar imagen</button>
            </div>
          </div>
        </div>
      )}
      </>
    );
  };

  return (
    <div style={{minHeight:"100vh",background:"#f0ebf7",fontFamily:"Nunito,sans-serif"}}>
      <header style={{background:`linear-gradient(135deg,${C.purple},${C.pink})`,padding:"0 20px",height:58,display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:100,boxShadow:"0 2px 16px rgba(45,26,46,.2)"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <span style={{fontSize:20}}>🧶</span>
          <div>
            <div style={{fontFamily:"Playfair Display,serif",color:"white",fontSize:15,fontWeight:700,lineHeight:1}}>Abu · Pedidos</div>
            <div style={{color:"rgba(255,255,255,.55)",fontSize:10,letterSpacing:"1.5px",textTransform:"uppercase"}}>Panel Privado</div>
          </div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <div style={{background:"rgba(255,255,255,.15)",borderRadius:20,padding:"4px 12px",display:"flex",alignItems:"center",gap:6}}>
            <div style={{width:7,height:7,borderRadius:"50%",background:capColor}}/>
            <span style={{color:"white",fontSize:12,fontWeight:700}}>{active}/{max}</span>
          </div>
          <button onClick={()=>setShowNew(true)} style={{background:"white",border:"none",borderRadius:50,padding:"7px 14px",fontFamily:"Nunito,sans-serif",fontSize:13,fontWeight:800,color:C.pink,cursor:"pointer"}}>+ Pedido</button>
          <button onClick={onExit} style={{background:"rgba(255,255,255,.15)",border:"none",borderRadius:50,padding:"7px 12px",fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:700,color:"rgba(255,255,255,.9)",cursor:"pointer"}}>← Salir</button>
        </div>
      </header>

      <div style={{maxWidth:960,margin:"0 auto",padding:"18px 14px"}}>
        <div style={{display:"flex",gap:3,marginBottom:18,background:"white",borderRadius:12,padding:3,width:"fit-content",boxShadow:"0 2px 8px rgba(45,26,46,.06)"}}>
          {[["orders","📋 Pedidos"],["stats","📊 Stats"],["stock","📦 Stock & Productos"]].map(([k,l])=>(
            <button key={k} onClick={()=>setTab(k)} style={{padding:"8px 14px",borderRadius:9,border:"none",fontFamily:"Nunito,sans-serif",fontSize:13,fontWeight:700,cursor:"pointer",background:tab===k?`linear-gradient(135deg,${C.pink},${C.purple})`:"transparent",color:tab===k?"white":C.brownMd,transition:"all .2s"}}>{l}</button>
          ))}
        </div>

        {/* STATS TAB */}
        {tab==="stats" && (
          <div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:12,marginBottom:18}}>
              {[
                {icon:"🧶",label:"Activos",value:`${active}/${max}`,color:C.pink},
                {icon:"⏳",label:"Pendientes",value:orders.filter(o=>o.status==="pending").length,color:"#f59e0b"},
                {icon:"🪡",label:"Tejiendo",value:orders.filter(o=>o.status==="weaving").length,color:C.purple},
                {icon:"💰",label:"Ingresos",value:fmtMoney(totalRevenue),color:"#10b981"},
              ].map((s,i)=>(
                <div key={i} style={{background:"white",borderRadius:16,padding:16,border:`1.5px solid ${C.paper}`}}>
                  <div style={{fontSize:24,marginBottom:6}}>{s.icon}</div>
                  <div style={{fontSize:20,fontWeight:800,color:s.color}}>{s.value}</div>
                  <div style={{fontSize:13,fontWeight:700,color:C.brown,marginTop:2}}>{s.label}</div>
                </div>
              ))}
            </div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              <div style={{background:"white",borderRadius:16,padding:16,border:`1.5px solid ${C.paper}`}}>
                <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13,color:C.brown,marginBottom:10}}>Capacidad Total</div>
                <div style={{background:C.paper,borderRadius:20,height:12,overflow:"hidden",marginBottom:6}}>
                  <div style={{height:"100%",borderRadius:20,width:`${Math.min(pct,100)}%`,background:pct>=90?`linear-gradient(90deg,#f59e0b,#ef4444)`:pct>=70?`linear-gradient(90deg,#10b981,#f59e0b)`:`linear-gradient(90deg,${C.pink},${C.purple})`,transition:"width .5s"}}/>
                </div>
                <div style={{fontFamily:"Nunito,sans-serif",fontSize:12,color:capColor,fontWeight:700}}>
                  {pct>=90?"¡Capacidad llena!":pct>=70?"Carga alta":pct>=40?"Carga moderada":"Disponible"}
                </div>
              </div>
              <div style={{background:"white",borderRadius:16,padding:16,border:`1.5px solid ${C.paper}`}}>
                <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13,color:C.brown,marginBottom:10}}>Por Producto</div>
                {allProducts.map(p=>{
                  const c = productLoad[p.id]||0;
                  const pct2 = Math.round(c/MAX_PER_PRODUCT*100);
                  const col = pct2>=100?"#ef4444":pct2>=75?"#f59e0b":"#10b981";
                  return (
                    <div key={p.id} style={{marginBottom:7}}>
                      <div style={{display:"flex",justifyContent:"space-between",marginBottom:2}}>
                        <span style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:C.brownMd,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:120}}>{p.name}</span>
                        <span style={{fontFamily:"Nunito,sans-serif",fontSize:11,fontWeight:700,color:col,flexShrink:0}}>{c}/{MAX_PER_PRODUCT}</span>
                      </div>
                      <div style={{background:C.paper,borderRadius:10,height:6,overflow:"hidden"}}>
                        <div style={{height:"100%",borderRadius:10,width:`${Math.min(pct2,100)}%`,background:pct2>=100?"#ef4444":pct2>=75?"#f59e0b":`linear-gradient(90deg,${C.pink},${C.purple})`,transition:"width .4s"}}/>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div style={{marginTop:14,background:"white",borderRadius:16,padding:16,border:`1.5px solid ${C.paper}`}}>
              <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13,color:C.brown,marginBottom:12}}>Estado de Pedidos</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                {Object.entries(ORDER_STATUS).map(([k,cfg])=>(
                  <div key={k} style={{background:cfg.bg,borderRadius:12,padding:"10px 14px",border:`1.5px solid ${cfg.color}33`,textAlign:"center",minWidth:80}}>
                    <div style={{fontSize:20}}>{cfg.icon}</div>
                    <div style={{fontWeight:800,fontSize:18,color:cfg.color}}>{orders.filter(o=>o.status===k).length}</div>
                    <div style={{fontSize:10,color:cfg.color,fontWeight:700,marginTop:2}}>{cfg.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ORDERS TAB */}
        {tab==="orders" && (
          <div>
            <div style={{background:"white",borderRadius:14,padding:"11px 14px",marginBottom:14,display:"flex",flexWrap:"wrap",gap:8,alignItems:"center",border:`1.5px solid ${C.paper}`}}>
              <div style={{position:"relative",flex:"1 1 150px"}}>
                <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",opacity:.4}}>🔍</span>
                <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Buscar..."
                  style={{width:"100%",padding:"8px 10px 8px 28px",borderRadius:50,border:`2px solid ${C.paper}`,fontSize:13,outline:"none",background:C.cream,boxSizing:"border-box"}}
                  onFocus={e=>e.target.style.borderColor=C.pink} onBlur={e=>e.target.style.borderColor=C.paper}/>
              </div>
              <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                {[["all","Todos"],["pending","Pendiente"],["weaving","Tejiendo"],["ready","Listo"],["shipped","Enviado"],["delivered","Entregado"]].map(([v,l])=>(
                  <button key={v} onClick={()=>setFilter(v)} style={{padding:"5px 11px",borderRadius:20,border:`2px solid ${filter===v?C.pink:C.paper}`,background:filter===v?C.pink:"transparent",color:filter===v?"white":C.brownMd,fontFamily:"Nunito,sans-serif",fontSize:12,fontWeight:700,cursor:"pointer",transition:"all .15s"}}>{l}</button>
                ))}
              </div>
              <span style={{fontSize:12,color:C.brownLt}}>{filtered.length} pedidos</span>
            </div>
            {filtered.length===0?(
              <div style={{textAlign:"center",padding:"44px 0",color:C.brownLt}}>
                <div style={{fontSize:44,marginBottom:10}}>🧶</div>
                <div style={{fontSize:15,fontWeight:700}}>No hay pedidos</div>
              </div>
            ):(
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {filtered.map(order=>{
                  const safeOrderItems = Array.isArray(order.items) ? order.items : [];
                  const { total } = calcTotals(safeOrderItems, order.shippingZone);
                  const cfg = ORDER_STATUS[order.status] || ORDER_STATUS.pending;
                  const customerName = order.customer?.name || "Cliente sin nombre";
                  return (
                    <div key={order.id} onClick={()=>setSelected(order)}
                      style={{background:"white",borderRadius:14,padding:"14px 18px",border:`1.5px solid ${C.paper}`,cursor:"pointer",display:"flex",alignItems:"center",gap:12,flexWrap:"wrap",transition:"all .18s"}}
                      onMouseEnter={e=>{e.currentTarget.style.borderColor=C.pink;e.currentTarget.style.transform="translateY(-1px)";}}
                      onMouseLeave={e=>{e.currentTarget.style.borderColor=C.paper;e.currentTarget.style.transform="translateY(0)";}}>
                      <div style={{width:9,height:9,borderRadius:"50%",background:cfg.color,flexShrink:0}}/>
                      <div style={{flex:"1 1 130px"}}>
                        <div style={{fontWeight:800,fontSize:14,color:C.brown}}>{customerName}</div>
                        <div style={{fontSize:11,color:C.brownLt}}>{order.id} · {fmtDate(order.createdAt)}</div>
                      </div>
                      <div style={{flex:"2 1 150px",fontSize:13,color:C.brownMd,overflow:"hidden"}}>
                        {order.items.map(i=>`${i.name} ×${i.qty}`).join(" + ")}
                        {order.notes&&<div style={{fontSize:11,color:C.brownLt,marginTop:1,fontStyle:"italic",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",maxWidth:200}}>📝 {order.notes}</div>}
                      </div>
                      <div style={{textAlign:"right",flexShrink:0}}>
                        <div style={{fontWeight:800,fontSize:15,color:C.pink}}>{fmtMoney(total)}</div>
                        <div style={{fontSize:11,marginTop:2}}>{order.isPaid?<span style={{color:"#10b981",fontWeight:700}}>✅ Pagado</span>:<span style={{color:"#f59e0b",fontWeight:700}}>⏳ Pendiente</span>}</div>
                      </div>
                      <span style={{flexShrink:0,fontFamily:"Nunito,sans-serif",fontSize:11,fontWeight:800,padding:"4px 10px",borderRadius:20,color:cfg.color,background:cfg.bg,border:`1.5px solid ${cfg.color}33`}}>{cfg.icon} {cfg.label}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* STOCK & PRODUCTS TAB */}
        {tab==="stock" && (
          <div>
            {/* Header row */}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:10}}>
              <div>
                <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:15,color:C.brown}}>
                  Catálogo · {allProducts.length} productos
                </div>
                <div style={{fontFamily:"Nunito,sans-serif",fontSize:12,color:C.brownLt,marginTop:2}}>
                  Agrega, edita o gestiona el stock de tus piezas
                </div>
              </div>
              <button onClick={()=>{ setEditProduct(null); setShowAddProduct(true); }}
                style={{display:"flex",alignItems:"center",gap:8,padding:"11px 20px",borderRadius:50,border:"none",
                  background:`linear-gradient(135deg,${C.pink},${C.purple})`,color:"white",
                  fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:800,cursor:"pointer",
                  boxShadow:`0 4px 0 ${C.pinkDk}`}}>
                ✨ Agregar Producto
              </button>
            </div>

            {/* Product list */}
            <div style={{display:"flex",flexDirection:"column",gap:10}}>
              {allProducts.map(p => {
                const sold = soldIds && soldIds.includes(p.id);
                const stockNum = typeof p.stock === "number" ? p.stock : 1;
                const outOfStock = sold || stockNum === 0;
                return (
                  <div key={p.id} style={{background:"white",borderRadius:14,padding:"14px 16px",
                    border:`1.5px solid ${outOfStock?"#fecaca":C.paper}`,
                    display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
                    <img src={p.img} alt={p.name} style={{width:58,height:58,objectFit:"cover",
                      borderRadius:12,flexShrink:0,filter:outOfStock?"grayscale(50%)":"none",
                      border:`1.5px solid ${C.paper}`}}/>
                    <div style={{flex:1,minWidth:120}}>
                      <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                        <div style={{fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:800,color:C.brown}}>{p.name}</div>
                        <span style={{fontFamily:"Nunito,sans-serif",fontSize:9,fontWeight:800,padding:"2px 7px",borderRadius:10,background:`${C.purple}22`,color:C.purple}}>
                          {p.isCustom ? "CUSTOM" : "CATALOG"}
                        </span>
                      </div>
                      <div style={{fontFamily:"Nunito,sans-serif",fontSize:12,color:C.brownLt,marginTop:2}}>
                        <span style={{fontWeight:800,color:C.pink}}>{fmtMoney(p.price)}</span>
                        <span style={{margin:"0 6px"}}>·</span>
                        {p.cat}
                        <span style={{margin:"0 6px"}}>·</span>
                        {outOfStock
                          ? <span style={{color:"#ef4444",fontWeight:700}}>Agotado</span>
                          : <span style={{color:"#10b981",fontWeight:700}}>
                              {stockNum === 1 ? "¡Última unidad!" : `${stockNum} unidades`}
                            </span>
                        }
                      </div>
                    </div>
                    <div style={{display:"flex",gap:7,flexShrink:0,flexWrap:"wrap",alignItems:"center"}}>
                      {outOfStock && (
                        <button onClick={()=>onRestock(p.id)}
                          style={{padding:"6px 12px",borderRadius:20,border:`2px solid ${C.pink}`,
                            background:C.rose,fontFamily:"Nunito,sans-serif",fontSize:12,
                            fontWeight:800,color:C.pink,cursor:"pointer"}}>
                          ↺ Reponer
                        </button>
                      )}
                      <button onClick={()=>{ setEditProduct(p); setShowAddProduct(true); }}
                        style={{padding:"6px 12px",borderRadius:20,border:`2px solid ${C.paper}`,
                          background:C.paper,fontFamily:"Nunito,sans-serif",fontSize:12,
                          fontWeight:800,color:C.brownMd,cursor:"pointer"}}>
                        ✏️ Editar
                      </button>
                      <button onClick={()=>{ if(window.confirm(`¿Eliminar "${p.name}"?`)) onDeleteProduct(p.id); }}
                        style={{padding:"6px 12px",borderRadius:20,border:"2px solid #fee2e2",
                          background:"#fef2f2",fontFamily:"Nunito,sans-serif",fontSize:12,
                          fontWeight:800,color:"#ef4444",cursor:"pointer"}}>
                        🗑
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {showNew  && <AdminNewOrder orders={orders} onSave={saveOrder} onClose={()=>setShowNew(false)} products={allProducts}/>}
      {selected && <AdminOrderDetail order={selected} onClose={()=>setSelected(null)} onUpdate={updateOrder} onDelete={deleteOrder}/>}
      {showAddProduct && (
        <ProductForm
          existing={editProduct}
          onClose={()=>{ setShowAddProduct(false); setEditProduct(null); }}
        />
      )}
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
//  MAIN SITE COMPONENT
// ─────────────────────────────────────────────────────────────────────────────

export default AdminDashboard;

